import { EmptyProjectIcon } from "../../../common/components/core/icons";

type NoProjectProps = {
    className?: string;
    canCreateProject: boolean;
};

const NoProject = ({
    className,
    canCreateProject,
}: NoProjectProps): JSX.Element => {
    return (
        <div className={`text-center ${className || ""}`}>
            <EmptyProjectIcon className="mb-3" />
            <p className="fs-6 fw-bolder text-label-grey mb-2">No Projects</p>
            <p className="fw-bold text-placeholder-grey">
                {canCreateProject
                    ? "Create new projects and they will appear here"
                    : "Any new projects will appear here"}
            </p>
        </div>
    );
};

export default NoProject;
